import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { IconModule } from 'studio-components/icon/icon.module';
import { ClipboardCopyComponent } from './clipboard-copy.component';

@NgModule({
  declarations: [ClipboardCopyComponent],
  imports: [CommonModule, MatSnackBarModule, IconModule, ClipboardModule],
  exports: [ClipboardCopyComponent],
})
export class ClipboardCopyModule {}
